module.exports = __webpack_public_path__ + "static/media/killer-bee-hazard-suit.689fdee3.png";